/* eslint-disable */
import React from 'react'
import { property } from './transformProperty'
import { isIOS } from '../../utils/config'
import { MouseEvent, TouchEvent } from 'react'
// import _ from "lodash";
import debounce from 'lodash/debounce'
interface ReactSiemaProps {
  resizeDebounce?: number,
  duration: number,  //动画时间
  easing?: string,
  perPage?: number,   //每页几张卡片
  startIndex: number,  //首次加载页面的index
  draggable?: boolean,
  threshold?: number,
  loop?: boolean,
  children: React.ReactElement[],
  onInit?: () => void,
  onChange: () => void,  //翻页
  onLoadPrevious: () => void,  //加载更多
  onClick?: (e: MouseEvent) => void,
  loadPreviousThreshold?: number, //发出下次请求的间隔时长
}
type Drag = {
  startX: number,
  endX: number,
  startY: number,
  letItGo: boolean | null,
  start?: number,
  end?: number
}

export class ReactSiema extends React.Component<ReactSiemaProps, {}> {
  config: any;
  currentSlide!: number;
  onResize!: (e: Event) => void;
  pointerDown: boolean = false;
  events: string[] = [
    'onTouchStart', 'onTouchEnd', 'onTouchMove', 'onTouchCancel'
  ];
  drag: Drag = {
    startX: 0,
    endX: 0,
    startY: 0,
    letItGo: null,
  };
  perPage!: number;
  selectorWidth!: number;

  sliderFrame: HTMLElement | null = null;

  selector: HTMLElement | null = null;
  innerElements!: HTMLElement[];
  wasDragged = false;

  constructor(props: ReactSiemaProps) {
    super(props)
    this.config = Object.assign({}, {
      resizeDebounce: 250,
      duration: 200,
      easing: 'ease-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      threshold: 20,
      loop: false,
      onInit: () => { },
      onChange: () => { },
      loadPreviousThreshold: 150,
    }, props)

    this.events.forEach((handler) => {
      this[handler] = this[handler].bind(this)
    })
  }

  componentDidMount() {
    this.config.selector = this.selector
    this.currentSlide = this.config.startIndex
    this.init()

    this.onResize = debounce(() => {
      this.resize();
      this.slideToCurrent();
      // 键盘收起
      window.scrollTo(0, 0)
    }, this.config.resizeDebounce)

    window.addEventListener('resize', this.onResize)

    if (this.config.draggable) {
      this.pointerDown = false
      this.drag = {
        startX: 0,
        endX: 0,
        startY: 0,
        letItGo: null,
      }
    }
  }
  shouldComponentUpdate(nextProps: any, nextState: any, nextContext: any) {
    if (nextProps !== this.props) {
      if (nextProps.children.length !== this.props.children.length) {
        return true;
      }

      for (let i = 0; i < nextProps.children.length; i++) {
        if (nextProps.children[i].key !== this.props.children[i].key) {
          return true;
        }
      }
    }
    return false;
  }
  componentDidUpdate() {
    this.init()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  init() {
    this.setSelectorWidth()
    this.setInnerElements()
    this.resolveSlidesNumber()

    const selectorHeight = this.selector ? this.selector.getBoundingClientRect().height : 0
    if (this.sliderFrame) {
      this.setStyle(this.sliderFrame, {
        width: `${(this.selectorWidth / this.perPage) * this.innerElements.length}px`,
        height: `${selectorHeight}px`,
        webkitTransition: `all 0ms ${this.config.easing}`,
        transition: `all 0ms ${this.config.easing}`,
      })
    }
    for (let i = 0; i < this.innerElements.length; i++) {
      this.setStyle(this.innerElements[i], {
        width: `${100 / this.innerElements.length}%`,
      })
    }

    if (this.pointerDown) {
      // 当右拉加载更多时，如果有新的渲染，touch 事件会被迫停止。所以先恢复滑动的位置，之后手动调用onTouchEnd。
      if (this.sliderFrame) {
        this.sliderFrame.style[property] = `translate3d(${(this.currentSlide * (this.selectorWidth / this.perPage) + (this.drag.startX - this.drag.endX)) * -1}px, 0, 0)`
      }
      setTimeout((e) => {
        this.onTouchEnd(e)
      }, 100)
    } else {
      this.slideToCurrent()
    }
    this.config.onInit.call(this)
  }

  setSelectorWidth() {
    this.selectorWidth = this.selector ? this.selector.getBoundingClientRect().width : 0
  }

  setInnerElements() {
    if (this.sliderFrame) {
      this.innerElements = [].slice.call(this.sliderFrame.children)

    }
  }

  resolveSlidesNumber() {
    if (typeof this.config.perPage === 'number') {
      this.perPage = this.config.perPage
    } else if (typeof this.config.perPage === 'object') {
      this.perPage = 1
      for (const viewport in this.config.perPage) {
        if (window.innerWidth > Number(viewport)) {
          this.perPage = this.config.perPage[viewport]
        }
      }
    }
  }

  prev(n = 1, callback?: () => void) {
    if (this.currentSlide === 0 && this.config.loop) {
      this.currentSlide = this.innerElements.length - this.perPage
    } else {
      this.currentSlide = Math.max(this.currentSlide - Number(n), 0)
    }
    this.slideToCurrent()
    this.config.onChange.call(this)

    if (typeof callback === 'function') {
      callback()
    }
  }

  next(n = 1, callback?: () => void) {
    if (this.currentSlide === this.innerElements.length - this.perPage && this.config.loop) {
      this.currentSlide = 0
    } else {
      this.currentSlide = Math.min(this.currentSlide + Number(n), this.innerElements.length - this.perPage)
    }
    this.slideToCurrent()
    this.config.onChange.call(this)

    if (typeof callback === 'function') {
      callback()
    }
  }

  goTo(index: number) {
    this.currentSlide = Math.min(Math.max(index, 0), this.innerElements.length - 1)
    this.slideToCurrent()
    this.config.onChange.call(this)
  }

  slideToCurrent() {
    if (this.sliderFrame) {
      this.sliderFrame.style[property] = `translate3d(-${Math.round(this.currentSlide * (this.selectorWidth / this.perPage))}px, 0, 0)`
    }

  }

  updateAfterDrag() {
    const movement = this.drag.endX - this.drag.startX
    if (movement > 0 && Math.abs(movement) > this.config.threshold) {
      this.prev()
    } else if (movement < 0 && Math.abs(movement) > this.config.threshold) {
      this.next()
    }
    this.slideToCurrent()
  }

  resize() {
    this.resolveSlidesNumber()
    if (this.selector) {
      const selectorRect = this.selector.getBoundingClientRect()
      this.selectorWidth = selectorRect.width
      this.setStyle(this.sliderFrame, {
        width: `${(this.selectorWidth / this.perPage) * this.innerElements.length}px`,
        height: `${selectorRect.height}px`
      })
    }
  }

  clearDrag() {
    this.drag = {
      startX: 0,
      endX: 0,
      startY: 0,
      letItGo: null,
    }
  }

  setStyle(target: any, styles: any) {
    if (target) {
      Object.keys(styles).forEach((attribute) => {
        target.style[attribute] = styles[attribute]
      })
    }
  }

  onTouchStart(e: TouchEvent<HTMLDivElement>) {
    e.stopPropagation()
    this.pointerDown = true
    this.drag.startX = e.touches[0].pageX
    this.drag.startY = e.touches[0].pageY
  }

  onTouchEnd(e: TouchEvent<HTMLDivElement>) {
    if (e) {
      e.stopPropagation()
    }
    this.pointerDown = false
    this.setStyle(this.sliderFrame, {
      webkitTransition: `all ${this.config.duration}ms ${this.config.easing}`,
      transition: `all ${this.config.duration}ms ${this.config.easing}`,
    })
    if (this.drag.endX) {
      this.updateAfterDrag()
    }
    this.clearDrag()
  }

  onTouchCancel(e: TouchEvent<HTMLDivElement>) {
    this.onTouchEnd(e)
  }

  onTouchMove(e: TouchEvent<HTMLDivElement>) {
    e.stopPropagation()
    // ios中, move为负时触发了页面返回操作,不用响应滑动
    const disbleSlide = isIOS && e.touches[0].pageX < 0
    if (this.drag.letItGo === null) {
      // 水平滑动 && ios不在返回状态中
      this.drag.letItGo = Math.abs(this.drag.startY - e.touches[0].pageY) < Math.abs(this.drag.startX - e.touches[0].pageX)
        && !disbleSlide
    } else if (this.drag.letItGo && disbleSlide) {
      this.drag.letItGo = false
      this.drag.endX = 0
      this.slideToCurrent()
    }
    if (this.pointerDown && this.drag.letItGo) {
      this.drag.endX = e.touches[0].pageX

      const slideToEdge = (this.currentSlide === 0 && (this.drag.endX - this.drag.startX) > this.selectorWidth / 2) ||
        (this.currentSlide === (this.innerElements.length - 1) && (this.drag.startX - this.drag.endX) > this.selectorWidth / 2)

      if (!slideToEdge) {
        this.setStyle(this.sliderFrame, {
          webkitTransition: `all 0ms ${this.config.easing}`,
          transition: `all 0ms ${this.config.easing}`,
          [property]: `translate3d(${(this.currentSlide * (this.selectorWidth / this.perPage) + (this.drag.startX - this.drag.endX)) * -1}px, 0, 0)`,
        })
      }

      // 判断是否触发右拉加载更多事件
      if (this.currentSlide === 0 && (this.drag.endX - this.drag.startX) > this.config.loadPreviousThreshold) {
        this.props.onLoadPrevious && this.props.onLoadPrevious()
      }
    }
  }

  onMouseDown(e: MouseEvent<HTMLDivElement>) {
    e.preventDefault()
    e.stopPropagation()
    this.pointerDown = true
    this.drag.start = e.pageX
    this.wasDragged = false
  }

  onMouseUp(e: MouseEvent<HTMLDivElement>) {
    e.stopPropagation()
    this.pointerDown = false
    this.setStyle(this.sliderFrame, {
      cursor: '-webkit-grab',
      webkitTransition: `all ${this.config.duration}ms ${this.config.easing}`,
      transition: `all ${this.config.duration}ms ${this.config.easing}`,
    })
    if (this.drag.end) {
      // If drag.end has a value > 0, the slider has been dragged
      this.wasDragged = true
      this.updateAfterDrag()
    }
    this.clearDrag()
  }

  onMouseMove(e: MouseEvent<HTMLDivElement>) {
    e.preventDefault()
    if (this.pointerDown) {
      this.drag.endX = e.pageX
      this.setStyle(this.sliderFrame, {
        cursor: '-webkit-grabbing',
        webkitTransition: `all 0ms ${this.config.easing}`,
        transition: `all 0ms ${this.config.easing}`,
        [property]: `translate3d(${(this.currentSlide * (this.selectorWidth / this.perPage) + (this.drag.startX - this.drag.endX)) * -1}px, 0, 0)`,
      })
    }
  }

  onMouseLeave(e: MouseEvent<HTMLDivElement>) {
    if (this.pointerDown) {
      this.pointerDown = false
      this.drag.endX = e.pageX
      this.setStyle(this.sliderFrame, {
        cursor: '-webkit-grab',
        webkitTransition: `all ${this.config.duration}ms ${this.config.easing}`,
        transition: `all ${this.config.duration}ms ${this.config.easing}`,
      })
      this.updateAfterDrag()
      this.clearDrag()
    }
  }

  onClick(e: MouseEvent) {
    if (!this.wasDragged && this.props.onClick) {
      this.props.onClick(e)
    }
  }

  cloneElement = (child: React.ReactElement, index: number) => {
    return React.cloneElement(child, {
      key: index,
      style: { float: 'left', height: '100%' },
      onClick: this.onClick,
    })
  }

  render() {
    return (
      <div
        ref={selector => this.selector = selector}
        style={{ overflow: 'hidden', height: '100%' }}
        {...this.events.reduce((props, event) => Object.assign({}, props, { [event]: this[event] }), {})}>
        <div ref={sliderFrame => this.sliderFrame = sliderFrame}>
          {
            React.Children.map(this.props.children, this.cloneElement)
          }
        </div>
      </div>
    )
  }
}
